// vendors
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import { useState } from "react";

// components
import Input from "../../../Components/Input";
import UISelect from "../../../Components/Select";

// helpers

import { useEffect } from "react";
import { dateCalendarClasses } from "@mui/x-date-pickers";

type Header = {
  id?: string;
  link?: string;
  type: string;
  filename?: string;
  text?: string;
};
type Errors = {
  header: {
    textError: boolean;
    uploadError: boolean;
  };
};
type InteractiveCatalogueHeaderProps = {
  characterLimit: number;
  data: {
    id?: string;
    link?: string;
    type: string;
    filename?: string;
    text?: string;
  };
  isList?: boolean;
  notAllow?: any;
  onChange: (data: any) => void;
  type?: string;
};

const InteractiveCatalogueHeader = ({
  characterLimit,
  data,
  onChange,
  isList,
  notAllow,
  type,
}: InteractiveCatalogueHeaderProps) => {
  console.log("🚀 ~ type:", type);
  console.log("data", data);
  const [headerType, updateHeaderType] = useState(data.type || "text");
  const [headerSelectOptions, setHeaderSelectOptions] = useState<any>([
    { label: "Text", value: "text" },
  ]);
  const [componentErrors, updateComponentErrors] = useState<Errors>({
    header: {
      textError: false,
      uploadError: false,
    },
  });
  const [header, updateHeader] = useState<Header>(data || {});
  const [uploadedData, updateUploadedData] = useState<any>(data || {});
  console.log("🚀 ~ uploadedData:", uploadedData);

  const handleHeaderOptionChange = (event: any) => {
    updateUploadedData({ type: event.target.value });
    updateHeaderType(event.target.value);
    onChange(event.target);
  };

  const handleHeaderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (value.length > characterLimit) return;
    updateHeader(data);
    onChange(data);
  };

  const validateInput = () => {
    updateComponentErrors({
      header: {
        ...componentErrors.header,
        textError:
          header?.text?.trim() === "" || Object.keys(header).length === 0,
      },
    });
  };
  useEffect(() => {
    validateInput();
    if (isList) {
      setHeaderSelectOptions([
        {
          label: "Text",
          value: "text",
        },
      ]);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <UISelect
        value={headerType}
        options={headerSelectOptions}
        onChange={handleHeaderOptionChange}
        isDisabled={isList}
      />
      {/* {headerType === "text" &&
        type === "multiple_product" &&
        !notAllow?.includes(headerType) && (
          <FormControl variant="standard" fullWidth sx={{ my: "16px" }}>
            <Input
              id="header"
              placeholder="Header"
              onChange={handleHeaderChange}
              value={header?.text}
              onBlur={validateInput}
              error={componentErrors.header.textError}
              {...{
                helperText: characterLimit ? (
                  <Typography variant="body2" align="right">
                    {`${
                      header?.text ? header?.text?.length : 0
                    }/${characterLimit}`}
                  </Typography>
                ) : (
                  ""
                ),
              }}
            />
          </FormControl>
        )} */}
      {headerType === "text" &&
      type === "multiple_product" &&
      !notAllow?.includes(headerType) ? (
        <FormControl variant="standard" fullWidth sx={{ my: "16px" }}>
          <Input
            id="header"
            placeholder="Header"
            onChange={handleHeaderChange}
            value={header?.text}
            onBlur={validateInput}
            error={componentErrors.header.textError}
            helperText={
              characterLimit ? (
                <Typography variant="body2" align="right">
                  {`${
                    header?.text ? header?.text?.length : 0
                  }/${characterLimit}`}
                </Typography>
              ) : (
                ""
              )
            }
          />
        </FormControl>
      ) : null}
    </>
  );
};
export default InteractiveCatalogueHeader;
